<section class="venue-hours"> <div class="ordering-open">{{ text.orderingHours }}:</div> <div class="ordering-hours">{{ orderingHoursString }}</div> </section> 